import { StepShell } from '../components/layout';
import { ChoiceCards } from '../components/selection';
import { Note } from '../components/inputs';

/**
 * Situational preferences. Framed as "what would you actually do" rather than
 * "what is the best answer", and never scored in front of the participant.
 */
export default function ScenariosStep({ data, update, notes = {}, config }) {
  const answers = data.answers || {};
  const scenarios = config.scenarios;
  const answered = scenarios.filter((s) => answers[s.key]).length;

  const setAnswer = (key, value) => {
    update({ answers: { ...answers, [key]: value } });
  };

  return (
    <StepShell
      eyebrow="Step 8 of 18"
      title="What would you actually do?"
      lede="A few situations you might run into. Pick whichever is closest to your real instinct — not the one that sounds most impressive."
      why="How people approach a messy situation tells us far more about where they will thrive than a list of qualifications does."
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <span className="ob-selected-count" data-met={answered === scenarios.length}>
          {answered} of {scenarios.length}
        </span>
      </div>

      {scenarios.map((scenario, index) => (
        <div key={scenario.key} className={index > 0 ? 'ob-divider' : undefined}>
          <ChoiceCards
            label={scenario.prompt}
            options={scenario.options}
            value={answers[scenario.key]}
            onChange={(value) => setAnswer(scenario.key, value)}
          />
        </div>
      ))}

      {notes.answers && <Note>{notes.answers}</Note>}
    </StepShell>
  );
}
